// extracted by mini-css-extract-plugin
export var cancelButton = "_nl-5";
export var content = "_nl-3";
export var createButton = "_nl-6";
export var drawerContainer = "_nl-0";
export var footer = "_nl-2";
export var header = "_nl-1";
export var orderFormColumn = "_nl-4";